import { render, staticRenderFns } from "./AllAbsences.vue?vue&type=template&id=2916a783&"
import script from "./AllAbsences.vue?vue&type=script&lang=js&"
export * from "./AllAbsences.vue?vue&type=script&lang=js&"
import style0 from "./AllAbsences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports